import { render, staticRenderFns } from "./VltTableHoverRowBtns.vue?vue&type=template&id=2052ab50&"
import script from "./VltTableHoverRowBtns.vue?vue&type=script&lang=js&"
export * from "./VltTableHoverRowBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports